exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_container__1wFpO{display:flex;align-items:center;margin:1rem;justify-content:center;flex-direction:column}", ""]);

// exports
exports.locals = {
	"container": "style_container__1wFpO"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/NotFound/style.less
// module id = 1808
// module chunks = 8